"use client";
import { usePublicationsFilter } from "@/contexts/publicationsSearch";
import clsx from "clsx";
import { ListFilter } from "lucide-react";

import { FC } from "react";

export const MobilePublicationsFilters: FC<{
  filtersForm: React.ReactNode;
}> = ({ filtersForm }) => {
  const { visibleMobile, setVisibleMobile } = usePublicationsFilter();

  return (
    <>
      <button
        onClick={() => setVisibleMobile(!visibleMobile)}
        className="block xl:hidden fixed z-20 bottom-4 right-4 bg-black text-white bg-line-pattern p-3 rounded-full"
      >
        <ListFilter size={24} />
      </button>

      <div
        className={clsx(
          "h-auto w-full fixed bottom-0 left-0 right-0 p-2 rounded-lg z-10 transition-transform duration-300 ease-in-out",
          !visibleMobile ? `translate-x-full` : `translate-x-0`
        )}
      >
        <div className="p-6 rounded-lg z-10 bg-brand-green bg-line-pattern">
          {filtersForm}
        </div>
      </div>
    </>
  );
};
